import setBroadcastSettings from 'actions/Broadcast/setBroadcastSettings';
import startProgram from 'actions/Broadcast/startProgram';
import setAttendeeMuteStatus from 'actions/Broadcast/setAttendeeMuteStatus';
import setStreamStatus from 'actions/Broadcast/setStreamStatus';
import { clearModal } from 'actions';
import updateSource from 'actions/source/updateSource';
import { AWAITING_KNOCK_APPROVAL } from 'constants/ModalTypes';
import initializeAgoraMeeting from '@shoflo/studio-redux/actions/meeting/initializeAgoraMeeting';
import updateMeetingStatus from '@shoflo/studio-redux/actions/meeting/updateMeetingStatus';
import {
  CAMERA_PRESENTER,
  SOURCE_ROLE_SPEAKER
} from '@studio/constants/Sources';
import { MEETING_STATUS } from '@studio/constants/Meeting';
import {
  NO_DEVICE_FOUND,
  PERMISSION_DENIED
} from '@studio/constants/ReadinessCheck';
import setAttendeeName from '@shoflo/studio-redux/actions/attendee/setAttendeeName';
import getCurrentBroadcast from '@shoflo/studio-redux/actions/broadcast/getCurrentBroadcast';
import createOrUpdateSource from '@shoflo/studio-redux/actions/source/createOrUpdateSource';

function agoraKnockAnswered(
  { dispatch, getState },
  {
    program,
    broadcastSettings,
    muteMeetingAudio,
    streamRecordStatus,
    sourceId
  },
  boundProgramChangedHandler
) {
  const role = SOURCE_ROLE_SPEAKER;
  const {
    program: currentProgram,
    audioInputDevice,
    videoInputDevice,
    user,
    knock: { name: title, description },
    readinessCheck: { camera },
    broadcastSources: { sources }
  } = getState();

  const attendeeId = `user-${user._id}`;
  if (!currentProgram) {
    boundProgramChangedHandler({ program });
  }
  const cameraUnavailable =
    camera === NO_DEVICE_FOUND || camera === PERMISSION_DENIED;

  // If a sourceId is provided, we need to clear any existing source associated with this user
  // That way we avoid having multiple sources for the same user when they knock multiple times and get approved each time
  // Even when the value/attendeeId is different
  if (sourceId) {
    const existingUserSource = sources.find(source => source.user === user._id);
    const existingUserSourceId = existingUserSource?._id;
    const isSameSource = existingUserSourceId === sourceId;

    if (!isSameSource && existingUserSourceId) {
      dispatch(updateSource(existingUserSource._id, { userId: '' }));
    }
  }

  const sourcePayload = {
    title,
    type: CAMERA_PRESENTER,
    value: attendeeId,
    description,
    userId: user._id,
    role,
    cameraUnavailable,
    sourceId
  };
  dispatch(setAttendeeName(attendeeId, title, '', role));
  dispatch(createOrUpdateSource(sourcePayload));

  dispatch(
    initializeAgoraMeeting({
      attendeeId,
      audioInputDeviceId: audioInputDevice,
      videoInput: videoInputDevice,
      setAttendeeMuteStatus
    })
  );
  const updatedBroadcastSettings = {
    ...broadcastSettings,
    muteMeetingAudio
  };
  dispatch(setBroadcastSettings(updatedBroadcastSettings));
  dispatch(setStreamStatus(streamRecordStatus));
  dispatch(clearModal(AWAITING_KNOCK_APPROVAL));
  dispatch(updateMeetingStatus(MEETING_STATUS.STARTED));
  dispatch(startProgram());
  dispatch(getCurrentBroadcast());
}

export default agoraKnockAnswered;
